<template>
	<v-layout row v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<choose-start-end
				v-model="old"
				:readonly="true"
				:number-of-modules="numberOfModules"
				:module-number="moduleNumber"
			></choose-start-end>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<choose-start-end
				v-model="current"
				:readonly="true"
				:number-of-modules="numberOfModules"
				:module-number="moduleNumber"
			></choose-start-end>
		</v-flex>
	</v-layout>
</template>

<script>
	import NewVersionMarker from "./NewVersionMarker";
	import OldVersionMarker from "./oldVersionMarker";
	import ChooseStartEnd from "../components/ChooseStartEnd";

	export default {
		name: "CompareStartEnd",
		components: {ChooseStartEnd, OldVersionMarker, NewVersionMarker},
		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			moduleNumber: {
				default: "",
			},
			numberOfModules: {
				default: 0,
			},
		}
	};
</script>

<style scoped>

</style>
